/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth/services/auth.service';

@Component({
  selector: 'ngx-auth',
  styleUrls: ['./auth.component.scss'],
  template: `
    <nb-layout>
      <nb-layout-column>
        <nb-card>
          <nb-card-body>
            <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12">
              <router-outlet></router-outlet>
            </div>
          </nb-card-body>
        </nb-card>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class NgxAuthComponent implements OnDestroy {

  subscription: any;

  authenticated = false;
  token = '';

  // showcase of how to use the onAuthenticationChange method
  constructor(
    protected auth: NbAuthService,
    protected router: Router,
  ) {
    try {
      this.subscription = auth.onAuthenticationChange()
        .subscribe((authenticated: boolean) => {
          this.authenticated = authenticated;
          if ( authenticated ) {
            this.router.navigateByUrl('/auth/authenticated');
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
